// src/utils/checkAndInsert.tsx
import { Dynamic, render } from "solid-js/web";
var checkAndInsert = (selector, component) => {
  const rootElement = document.documentElement;
  const isExist = rootElement.querySelector(`#${selector}`);
  if (isExist) {
    return isExist;
  }
  render(() => <Dynamic component={component} />, rootElement);
};

export {
  checkAndInsert
};
